import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Privacy.css';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="privacy-page">
        <div className="container">
          <div>
            <Link to="/" className="back-link">
              <ArrowLeft size={20} />
              Вернуться на главную
            </Link>
            
            <h1>Политика конфиденциальности и согласие на обработку персональных данных</h1>
            
            <p className="privacy-date">Дата последнего обновления: 13 апреля 2025 г.</p>
            
            <div className="privacy-content">
              <p>
                Настоящая Политика конфиденциальности персональных данных (далее – Политика) действует в 
                отношении всей информации, которую сайт компании «МИГРАНТ PRO», расположенный на 
                доменном имени https://мигрантпро.рф (далее – Сайт), может получить о Пользователе во время 
                использования Сайта, его сервисов, программ и продуктов.
              </p>

              <p>
                Использование сервисов Сайта, включая отправку формы обратной связи, означает безоговорочное 
                согласие Пользователя с настоящей Политикой и указанными в ней условиями обработки его 
                персональной информации; в случае несогласия с этими условиями Пользователь должен 
                воздержаться от использования сервисов.
              </p>

              <h2>1. Персональная информация пользователей, которую обрабатывает Сайт</h2>
              
              <h3>1.1. В рамках настоящей Политики под «персональной информацией Пользователя» понимаются:</h3>
              
              <p>
                <strong>1.1.1.</strong> Персональная информация, которую Пользователь предоставляет о себе самостоятельно при 
                заполнении форм на Сайте, включая, но не ограничиваясь: Имя, Контактный номер телефона. 
                Обязательная для предоставления информация помечена специальным образом (например, звездочкой). 
                Иная информация предоставляется Пользователем на его усмотрение.
              </p>

              <p>
                <strong>1.1.2.</strong> Данные, которые автоматически передаются сервисам Сайта в процессе их использования с 
                помощью установленного на устройстве Пользователя программного обеспечения, в том числе 
                IP-адрес, данные файлов cookie, информация о браузере Пользователя (или иной программе, с 
                помощью которой осуществляется доступ к сервисам), технические характеристики оборудования и 
                программного обеспечения, используемых Пользователем, дата и время доступа к сервисам, адреса 
                запрашиваемых страниц и иная подобная информация. Эти данные используются для улучшения 
                работы сайта и анализа посещаемости.
              </p>

              <p>
                <strong>1.2.</strong> Настоящая Политика применима только к информации, обрабатываемой в ходе использования Сайта. 
                Сайт не контролирует и не несет ответственность за обработку информации сайтами третьих лиц, 
                на которые Пользователь может перейти по ссылкам, доступным на Сайте (например, виджеты 
                Яндекс Карт).
              </p>

              <p>
                <strong>1.3.</strong> Сайт не проверяет достоверность персональной информации, предоставляемой Пользователем, и не 
                имеет возможности оценивать его дееспособность. Однако Сайт исходит из того, что пользователь 
                предоставляет достоверную и достаточную персональную информацию и поддерживает эту 
                информацию в актуальном состоянии.
              </p>

              <h2>2. Цели обработки персональной информации пользователей</h2>
              
              <p><strong>2.1.</strong> Сайт собирает и хранит только ту персональную информацию, которая необходима для предоставления услуг или исполнения соглашений и договоров с Пользователем (например, для ответа на заявку), за исключением случаев, когда законодательством предусмотрено обязательное хранение персональной информации в течение определенного законом срока.</p>
              
              <h2>3. Условия обработки персональной информации пользователей и её передачи третьим лицам</h2>
              
              <p><strong>3.1.</strong> Сайт хранит персональную информацию Пользователей в соответствии с внутренними регламентами и требованиями законодательства РФ.</p>
              
              <p><strong>3.2.</strong> В отношении персональной информации Пользователя сохраняется ее конфиденциальность, кроме случаев добровольного предоставления Пользователем информации о себе для общего доступа неограниченному кругу лиц.</p>
              
              <h2>4. Обязательства сторон</h2>
              
              <p><strong>4.1.</strong> Пользователь обязуется предоставить корректную и правдивую информацию о персональных данных, необходимую для пользования Сайтом.</p>
              
              <p><strong>4.2.</strong> Администрация Сайта обязуется использовать полученную информацию исключительно для целей, указанных в настоящей Политике конфиденциальности.</p>
              
              <h2>5. Изменение и удаление персональной информации. Отзыв согласия</h2>
              
              <p><strong>5.1.</strong> Пользователь может в любой момент изменить (обновить, дополнить) предоставленную им персональную информацию или её часть, обратившись к Администрации Сайта по контактным данным, указанным на Сайте.</p>
              
              <p><strong>5.2.</strong> Пользователь также может отозвать свое согласие на обработку персональных данных путем направления письменного уведомления Компании по юридическому адресу или на адрес электронной почты 9252461666@ya.ru.</p>
              
              <h2>6. Меры, применяемые для защиты персональной информации пользователя</h2>
              
              <p><strong>6.1.</strong> Сайт принимает необходимые и достаточные организационные и технические меры для защиты персональной информации Пользователя от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий с ней третьих лиц.</p>
              
              <h2>7. Изменение Политики конфиденциальности. Применимое законодательство</h2>
              
              <p><strong>7.1.</strong> Администрация Сайта вправе вносить изменения в настоящую Политику конфиденциальности без согласия Пользователя. Новая редакция Политики вступает в силу с момента ее размещения на Сайте, если иное не предусмотрено новой редакцией Политики.</p>
              
              <p><strong>7.2.</strong> К настоящей Политике и отношениям между Пользователем и Администрацией Сайта, возникающим в связи с применением Политики конфиденциальности, подлежит применению право Российской Федерации.</p>
              
              <h2>8. Обратная связь. Вопросы и предложения</h2>
              
              <p>
                Все предложения или вопросы по поводу настоящей Политики Пользователь вправе направлять 
                Администрации Сайта по контактным данным, указанным в разделе «Контакты» на Сайте, или на 
                адрес электронной почты <a href="mailto:9252461666@ya.ru">9252461666@ya.ru</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;